export function getToken() {
  return localStorage.getItem('TOKEN');
}
export function getEmail() {
  return localStorage.getItem('EMAIL');
}
export function getLoginType() {
  return localStorage.getItem('LOGIN_TYPE');
}
export function getUrlKey(name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}
